import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Container, InputContainer, Form, Input } from '../styles';
import { changePassword } from '../api';
import { Button, Logo } from '../components';

const NewPassword = () => {
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [passwordWarning, setPasswordWarning] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Obtém o token da URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      setResponseMessage('Token não encontrado na URL. Verifique o link de redefinição de senha.');
      return;
    }

    if (newPassword === confirmPassword) {
      setIsLoading(true);
      setResponseMessage('');
      setPasswordWarning('');

      try {

        const response = await changePassword(newPassword, token);

        const data = await response.json();
        
        if (response.ok) {
          setResponseMessage(data.message || 'Senha alterada com sucesso.');

          navigate('/success-password');

        } else {
          setResponseMessage(data.message || 'Erro ao alterar senha.');
        }

      } catch (error) {
        setResponseMessage('Erro de rede. Tente novamente mais tarde.');

      } finally {
        setIsLoading(false);
      }

    } else {
      setPasswordWarning('As senhas não coincidem. Tente novamente.');
    }
  };

  return (
    <Container>
      <InputContainer>
        <Logo alt="Blue House Tennis" width="200px" height="auto" />
        <Form onSubmit={handleSubmit}>
          <h2 style={{ color: 'white', fontSize: '23px', fontFamily: 'Bellota' }}>Nova Senha</h2>
          <label style={{ color: 'white', textAlign: 'center', fontSize: '14px' }}>
            Digite sua nova senha:
            <Input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              style={{ borderBottom: '1px solid white', marginBottom: '40px' }}
            />
          </label>
          <label style={{ color: 'white', textAlign: 'center', fontSize: '14px' }}>
            Confirme sua nova senha:
            <Input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={{ borderBottom: '1px solid white', marginBottom: '40px' }}
            />
          </label>
          {passwordWarning && <p style={{ color: 'red', textAlign: 'center', marginTop: '20px' }}>{passwordWarning}</p>}
          <Button type="submit" title={isLoading ? 'Salvando...' : 'SALVAR SENHA'} disabled={isLoading}></Button>
          {responseMessage && <p style={{ color: 'white', textAlign: 'center', marginTop: '20px' }}>{responseMessage}</p>}
        </Form>
      </InputContainer>
    </Container>
  );
};

export default NewPassword;
